import { render, staticRenderFns } from "./AppointEditCont.vue?vue&type=template&id=afb819c2&"
import script from "./AppointEditCont.vue?vue&type=script&lang=js&"
export * from "./AppointEditCont.vue?vue&type=script&lang=js&"
import style0 from "./AppointEditCont.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports